export default __webpack_public_path__ + "static/media/notif.a673b70c.wav";